export default __webpack_public_path__ + "static/thumb-landscape-c225782ca6242f9601da414bb091bcb5.jpg";